import styled from "styled-components";
import Checkbox from "../../components/Checkbox";
import SelectField from "../../components/SelectField";
import { TextFont, Colors } from "../../config";
import {
  EXCEPTIONAL_NATIONALITIES,
  ONLY_SELFPAID,
  PAYMENT_TYPES,
  TRAVEL_CLASS,
} from "../../config/Constants";
import SapError from "../../components/SapError";
import { useDestinationContext } from "../../contexts/DestinationContext";
import InputField from "../../components/InputField";
import InputDatePicker from "../../components/Datepicker";
import UploadDocument from "../../components/UploadDocument";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const PassengerDetails = ({
  passengers,
  onCheckboxChange,
  onPaymentSelect,
  onTravelClassSelect,
  fellowPax,
  fieldError,
  sapErrorList,
  profileData,
  formData,
  onPassportNoAndExpiryChange,
  onDependentsPassportUpload,
}) => {
  // const handleCheckBox = (val, index) => {
  //   const updatedfellowPax = [...fellowPax];
  //   updatedfellowPax[index].selected = !updatedfellowPax[index].selected;
  //   setFellowPax(updatedfellowPax);
  // };
  const { destinations } = useDestinationContext();
  const { extraFields } = useExtraFieldsContext();
  const getTravelClass = (index) => {
    if (passengers[index].paymentType === "self paid") {
      return TRAVEL_CLASS;
    }
    if (passengers[index].relationshipStatus !== "Self") {
      return TRAVEL_CLASS.filter((item) => item.value !== "Business Class");
    }
    let grade = profileData?.grade?.split("-")[1];
    let gradeLimit =
      extraFields?.departmentCode === "70001"
        ? extraFields?.categoryType === "Support"
          ? 20
          : 19
        : 20;
    return Number(grade) <= Number(gradeLimit)
      ? TRAVEL_CLASS.filter((item) => item.value !== "Business Class")
      : TRAVEL_CLASS;
  };

  const getPaymentType = (passenger) => {
    let isOnlySelfPaid;
    if (passengers[0]?.employeeGroup === "Staff") {
      let selectedAirportCountry = destinations.filter(
        (dest) => dest.value === formData?.to
      )[0]?.country;

      let isExceptionCountry = EXCEPTIONAL_NATIONALITIES.includes(
        profileData?.territoryName
      );

      if (isExceptionCountry) {
        isOnlySelfPaid = passenger.ticketEncash <= 0;
      } else {
        let hasNoBalance = passenger.ticketEncash <= 0;
        let isOneWayTrip = !formData.returnJourney;
        let isNotGoingHomeCountry = selectedAirportCountry
          ? profileData?.territoryName !== selectedAirportCountry
          : false;
        isOnlySelfPaid = hasNoBalance || isOneWayTrip || isNotGoingHomeCountry;
      }
    } else {
      isOnlySelfPaid = true;
    }

    return isOnlySelfPaid
      ? PAYMENT_TYPES.filter((item) => item.value !== "company paid")
      : PAYMENT_TYPES;
  };

  return (
    <FellowPaxWrapper>
      <TextFont fontColor={Colors.brandTwo} fontSize="1.5rem" fontWeight="700">
        Passenger Details
      </TextFont>
      {passengers.map((passenger, index) => (
        <FellowPaxContainer key={index + 1}>
          <span>
            <Checkbox
              label={`${passenger.firstName} ${passenger.lastName} (${passenger.relationshipStatus})`}
              setIsChecked={(val) => onCheckboxChange(val, index)}
              fontColor={Colors.brandOne}
              isChecked={passenger.selected}
              helperText={
                !Array.isArray(fieldError.passengers) &&
                index === 0 &&
                fieldError.passengers
              }
            />
            {sapErrorList[index] !== "" && (
              <SapError errorMsg={sapErrorList[index]} />
            )}
          </span>
          {passenger.selected && (
            <>
              <div>
                <SelectField
                  name="paymentType"
                  label="Payment Type"
                  isRounded
                  placeholder="Payment Type"
                  // data={PAYMENT_TYPES}
                  data={getPaymentType(passenger)}
                  value={
                    // passenger?.ticketEncash === 0
                    //   ? "self paid"
                    //   :
                    passenger.paymentType
                  }
                  // disabled={hasTicketEncashZero ? true : false}
                  onChange={(e) => onPaymentSelect(e, index, "passengers")}
                  helperText={
                    Array.isArray(fieldError.passengers) &&
                    fieldError.passengers[index]?.paymentType
                  }
                />
                <SelectField
                  name="travelClass"
                  label="Travel Class"
                  isRounded
                  placeholder="Travel Class"
                  data={getTravelClass(index)}
                  value={passenger.travelType}
                  onChange={(e) => onTravelClassSelect(e, index, "passengers")}
                  helperText={
                    Array.isArray(fieldError.passengers) &&
                    fieldError.passengers[index]?.travelType
                  }
                />
              </div>
              {passenger.relationshipStatus !== "Self" && (
                <>
                  <div>
                    <InputField
                      label="Passport Number"
                      placeholder="Passport Number"
                      onChange={(e) =>
                        onPassportNoAndExpiryChange(
                          e.target.value,
                          e.target.name,
                          index
                        )
                      }
                      value={passenger.passportNo}
                      name="passportNo"
                      isRounded
                      helperText={
                        Array.isArray(fieldError.passengers) &&
                        fieldError.passengers[index]?.passportNo
                      }
                    />
                    <InputDatePicker
                      format="yyyy/MM/dd"
                      placeholder="Passport Expiry"
                      label="Passport Expiry"
                      value={
                        passengers[index]?.passportExpiry
                          ? new Date(passengers[index]?.passportExpiry)
                          : ""
                      }
                      onChange={(val) =>
                        onPassportNoAndExpiryChange(
                          val,
                          "passportExpiry",
                          index
                        )
                      }
                      helperText={
                        Array.isArray(fieldError.passengers) &&
                        fieldError.passengers[index]?.passportExpiry
                      }
                      minDate={new Date()}
                      name="passportExpiry"
                      dropdownMode="select"
                    />
                  </div>
                  <div>
                    <UploadDocument
                      value={passengers[index]["passportPdf"]}
                      selectedFileName={passengers[index]["firstName"] + ".pdf"}
                      disabled={passengers[index]["passportPdf"]}
                      onChange={(obj) => onDependentsPassportUpload(obj, index)}
                      helperText={
                        Array.isArray(fieldError.passengers) &&
                        fieldError.passengers[index]?.passportPdf
                      }
                      index={"passenger" + index}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </FellowPaxContainer>
      ))}
    </FellowPaxWrapper>
  );
};

const FellowPaxWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 0 1rem;
  }
`;

const FellowPaxContainer = styled.div`
  margin-top: 1rem;
  width: 100%;
  > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-top: 1rem;
    @media only screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }
  > span {
    display: flex;
    gap: 0.5rem;
    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

export default PassengerDetails;
